//
// A Fluxible store for the designs in a brief
//

import { BaseStore } from 'fluxible/addons';
import Immutable from 'immutable';

const MIN_SELECTION = 3;
const MAX_SELECTION = 10;

class BriefDesignStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.setDesigns([]);
        this.setSelectedDesigns([]);
    }

    load(payload) {
        if (payload.designs) {
            this.setDesigns(payload.designs);
        }

        if (payload.body.sample_designs) {
            this.setSelectedDesigns(payload.body.sample_designs);
        }
        this.emitChange();
    }

    updateDesigns(payload) {
        if (payload.designs) {
            this.setDesigns(payload.designs);
        }
        this.emitChange();
    }

    clearDesigns(payload) {
        this.setDesigns([]);
        this.setSelectedDesigns([]);
    }

    setDesigns(designs) {
        this.designs = new Immutable.OrderedSet(designs);
    }

    setSelectedDesigns(designs) {
        this.selectedDesigns = new Immutable.Set(designs);
    }

    toggleDesign(design) {
        if (!this.selectedDesigns.has(design)) {
            this.selectedDesigns = this.selectedDesigns.add(design);
        } else {
            this.selectedDesigns = this.selectedDesigns.delete(design);
        }
        this.emitChange();
    };

    getDesigns() {
        return this.designs;
    }

    getSelectedDesigns() {
        return this.selectedDesigns;
    }

    getPercentageComplete() {
        return (this.selectedDesigns.count() / MAX_SELECTION) * 100;
    }

    isSelectionDisabled() {
        return this.getPercentageComplete() >= 100;
    }

    isMinimumAmountSelected() {
        return (this.selectedDesigns.count() >= MIN_SELECTION);
    }

    findDesign(id) {
        return this.designs.find((design) => {
            return design.id === id;
        });
    }
}

BriefDesignStore.storeName = 'BriefDesignStore';
BriefDesignStore.handlers = {
    TOGGLE_DESIGN: 'toggleDesign',
    LOAD_DRAFT_DATA: 'load',
    CLEAR_DESIGNS: 'clearDesigns',
    SAVE_DRAFT_SUCCESS: 'updateDesigns',
};

export default BriefDesignStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefDesignStore.js